const BaseContainer = {
    props : {
        color      : { type : String, default : '' },
        hoverColor : { type : String, default : '' },

        padding      : { type : String, default : '3' },
        hoverPadding : { type : String, default : '' },

        hoverTransform : { type : String, default : '' },

        radius      : { type : String, default : '2' },
        hoverRadius : { type : String, default : '' },

        shadow      : { type : String, default : '' },
        hoverShadow : { type : String, default : '' }
    },
    data () {
        return {
            hover : false
        };
    },

    computed : {
        currentColor () {
            if (this.hover) {
                if (this.hoverColor) {
                    return this.hoverColor;
                }
            }
            return this.color;
        },
        currentShadow () {
            if (this.hover) {
                if (this.hoverShadow) {
                    return this.hoverShadow;
                }
            }
            return this.shadow;
        },
        currentRadius () {
            if (this.hover) {
                if (this.hoverRadius) {
                    return this.hoverRadius;
                }
            }
            return this.radius;
        },
        currentPadding () {
            if (this.hover) {
                if (this.hoverPadding) {
                    return this.hoverPadding;
                }
            }
            return this.padding;
        },

        currentBgClass () {
            const currentColor = this.currentColor;
            if (currentColor) {
                return 'bg-' + currentColor;
            }
            return '';
        },

        baseContainerClasses () {
            const names = ['trn'];
            const currentRadius = this.currentRadius;
            const currentShadow = this.currentShadow;
            const currentPadding = this.currentPadding;

            names.push(this.currentBgClass);

            if (currentRadius) {
                names.push('round-' + currentRadius);
            }
            if (currentShadow) {
                names.push('bs-' + currentShadow);
            }
            if (currentPadding) {
                names.push('p-' + currentPadding);
            }

            const additionalClasses = this.additionalClasses;
            if (additionalClasses) {
                names.push(additionalClasses);
            }

            if (this.hover) {
                if (this.hoverTransform) {
                    names.push(this.hoverTransform);
                }
            }
            return names.join(' ');
        }

    }
};

export default BaseContainer;
